import { render } from "./CatDetails.vue?vue&type=template&id=16457d92"
import script from "./CatDetails.vue?vue&type=script&lang=js"
export * from "./CatDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__